import { render, staticRenderFns } from "./BrandName.vue?vue&type=template&id=4d396484&scoped=true&"
import script from "./BrandName.vue?vue&type=script&lang=js&"
export * from "./BrandName.vue?vue&type=script&lang=js&"
import style0 from "./BrandName.vue?vue&type=style&index=0&id=4d396484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d396484",
  null
  
)

export default component.exports